import { combineReducers } from 'redux';
import manage, { ICommissaryManageState } from './commissary-manage';
import orders, { ICommissaryOrdersState } from './commissary-orders';
import order, { ICommissaryOrderState } from './commissary-order';

export interface ICommissaryState {
  manage: ICommissaryManageState;
  orders: ICommissaryOrdersState;
  order: ICommissaryOrderState;
}

export default combineReducers({
  manage,
  orders,
  order
});
